import {addOrReplaceAndRunAnalysisStep} from 'analysis-tool/AnalysisActions';
import {
  SINGLE_DATASET_OUTPUT_STEP_DATA_NAME,
  SINGLE_DATASET_INPUT_STEP_DATA_NAME,
} from 'analysis-tool/AnalysisStepDataNames';
import {ARCHIVED_ANALYSIS_TOOLTIP_TEXT} from 'analysis-tool/AnalysisToolConstants';
import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {isTopLevelAnalysisView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import isArchived from 'archive/isArchived';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {withLoadingScreen} from 'util/Promises';

export default function getPromoteViewAction(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL
): OverflowDataViewAction | null {
  const lastStep = view.lineage[view.lineage.length - 1].step;
  const promotedStepData = lastStep.outputStepDatas.find(
    ({name}) => name === SINGLE_DATASET_OUTPUT_STEP_DATA_NAME
  );

  if (
    promotedStepData == null ||
    promotedStepData.rawDatas.length === 0 ||
    isTopLevelAnalysisView(view) ||
    isAnalysisReadOnly(analysis)
  ) {
    return null;
  }

  return {
    icon: 'table',
    onClick: () => {
      withLoadingScreen(
        addOrReplaceAndRunAnalysisStep(analysis.id, {
          stepType: PipelineStepType.PROMOTE_DATASET,
          stepVersion: 0,
          stepConfig: {},
          stepInput: {
            inputDataFrameId: promotedStepData.rawDatas[0].id,
          },
          stepInputParents: {
            [SINGLE_DATASET_INPUT_STEP_DATA_NAME]: [
              {
                stepId: lastStep.id,
                stepDataName: SINGLE_DATASET_OUTPUT_STEP_DATA_NAME,
              },
            ],
          },
        })
      );
    },
    label: 'Promote view to top-level',
    isDisabled: isArchived(analysis),
    helpText: isArchived(analysis) ? ARCHIVED_ANALYSIS_TOOLTIP_TEXT : undefined,
  };
}
